import { env } from 'config/env'
import type { JWTPayload } from 'jose'

export const getOpenJwtToken = async (payload?: JWTPayload) => {
  const jose = await import('jose')
  const encodedSecret = new TextEncoder().encode(env.NEXT_PUBLIC_OPEN_JWT_SECRET)
  const alg = 'HS256'

  const signedToken = await new jose.SignJWT(payload || {}).setProtectedHeader({ alg }).sign(encodedSecret)

  return `Bearer ${signedToken}`
}
